import { FC } from "react";
import { usePrivilege } from "../../../components/priviledge/PriviledgeProvider";
import useParks from "../../../hooks/api-calls/useParks";
import useUsers from "../../../hooks/api-calls/useUsers";
import useCompanies from "../../../hooks/api-calls/useCompanies";
import useDocuments from "../../../hooks/api-calls/useDocuments";
import DateField from "../../../components/forms/DateField";
import { isEqual } from "lodash";
import CustomSelect from "../../../components/forms/CustomSelect";
import FormLabel from "../../../components/forms/FormLabel";
import CustomSearchInput from "../../../components/forms/CustomSearchInput";
import useClients from "../../../hooks/api-calls/useClients";
import { categoryOptions } from "../../../utils/SelectorMapping";


interface ReportFiltersProps {
    updateFilters: (filters: any) => void;
    resetFilters: (limit: any) => void;
    filters: any;
    isFromPark?: boolean;
}


const ReportFilters: FC<ReportFiltersProps> = ({ updateFilters, resetFilters, filters, isFromPark }) => {

    // HOOKS
    
    const { userCan } = usePrivilege();
    const { getParksList } = useParks();
    const { getUsersList } = useUsers();
    const { getCompaniesList } = useCompanies();
    const { getDocumentStatusList } = useDocuments();
    const { getClientsList } = useClients();


    // RENDER

    return (
        <>
            <DateField
                isClearable
                className="w-full"
                label="Fecha de generación"
                placeholderText="Selecciona las fechas"
                selectedDateField={filters.filter_filters?.between_dates?.type || "uploadedAt"}
                dateTypesOptions={[
                    { label: "Fecha de subida", value: "uploadedAt" },
                ]}
                startDate={filters.filter_filters?.between_dates?.startDate ? new Date(filters.filter_filters.between_dates.startDate) : null}
                endDate={filters.filter_filters?.between_dates?.endDate ? new Date(filters.filter_filters.between_dates.endDate) : null}
                onChange={(date: any) => {
                    const filters_between_dates = filters.filter_filters?.between_dates;
                    const between_dates = date ? { startDate: date[0], endDate: date[1] } : null;

                    if (between_dates && !isEqual(filters_between_dates, between_dates)) {
                        updateFilters({ between_dates: { startDate: date[0], endDate: date[1], type: date[2] } });
                    } else if (!between_dates && filters_between_dates) {
                        updateFilters({ between_dates: null });
                    }
                }}
            />

            <FormLabel label='Nombre'>
                <CustomSearchInput onSearch={(e) => updateFilters({ name: e })} defaultValue={filters.filter_filters?.name || ''} />
            </FormLabel>

            <FormLabel label='Descripción'>
                <CustomSearchInput onSearch={(e) => updateFilters({ description: e })} defaultValue={filters.filter_filters?.description || ''} />
            </FormLabel>

            <CustomSelect
                isSearchable
                id={'company'}
                label="Compañia"
                options={getCompaniesList()}
                onChange={(e: any) => { 
                    updateFilters({ company: e.value})
                }}
                value={
                    filters.filter_filters?.company
                        ? getCompaniesList().filter((company: any) => filters.filter_filters?.company.includes(company.value))
                        : null
                        
                }
                display={userCan('list', 'companies')}
            />

            <CustomSelect
                isSearchable
                id={'park'}
                label="Parque eólico"
                options={ getParksList() }
                onChange={(e: any) => {
                    if (e.value === null) {
                        updateFilters({ park: null });
                        return;
                    }
                    updateFilters({ park: e.value });
                }}
                value={filters.filter_filters?.park
                    ? getParksList().filter((park: any) => filters.filter_filters?.park.includes(park.value))
                    : null
                }
                isDisabled={isFromPark}
                display={userCan('admin_park', 'park')}

            />


            <CustomSelect
                isSearchable
                id={'status'}
                label="Estado del documento"
                options={ getDocumentStatusList() }
                onChange={(e: any) => {
                    if (e.value === null) {
                        updateFilters({ status: null });
                        return;
                    }
                    updateFilters({ status: e.value });
                }}
                value={filters.filter_filters?.status
                    ? getDocumentStatusList().filter((status: any) => filters.filter_filters?.status.includes(status.value))
                    : null
                }
            />  

            <CustomSelect
                isSearchable
                id={'category'}
                label="Categoría"
                options={ categoryOptions }
                onChange={(e: any) => {
                    if (e.value === null) {
                        updateFilters({ category: null });
                        return;
                    }
                    updateFilters({ category: e.value });
                }}
                value={filters.filter_filters?.category
                    ? categoryOptions.filter((type: any) => filters.filter_filters?.category.includes(type.value))
                    : null
                }
            />
            
            <CustomSelect
                isSearchable
                id={'user'}
                label="Usuario"
                options={ getUsersList() }
                onChange={(e: any) => {
                    if (e.value === null) {
                        updateFilters({ user: null });
                        return;
                    }
                    updateFilters({ user: e.value });
                }}
                value={filters.filter_filters?.user
                    ? getUsersList().filter((user: any) => filters.filter_filters?.user.includes(user.value))
                    : null
                }
                display={userCan('admin_user', 'user')}
            />

            <CustomSelect
                isSearchable
                id={'client'}
                label="Cliente"
                options={ getClientsList() }
                onChange={(e: any) => {
                    if (e.value === null) {
                        updateFilters({ client: null });
                        return;
                    }
                    updateFilters({ client: e.value });
                }}
                value={filters.filter_filters?.client
                    ? getClientsList().filter((client: any) => filters.filter_filters?.client.includes(client.value))
                    : null
                }
                display={userCan('admin_client', 'clients')}
            />
        </>


    )


}

export default ReportFilters;
